/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_ButtonInputs */

const he_home_cta_button = /** @type {(inputs: Home_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הרשמה להתראות`)
};

const en_home_cta_button = /** @type {(inputs: Home_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Up for Alerts`)
};

/**
* | output |
* | --- |
* | "Sign Up for Alerts" |
*
* @param {Home_Cta_ButtonInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_cta_button = /** @type {((inputs?: Home_Cta_ButtonInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_ButtonInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_cta_button(inputs)
	return en_home_cta_button(inputs)
});